import { mapState } from "vuex";

export const computed = {
  ...mapState('solicitacaoBaixa', ['solicitacoes'])
}
